import { Component, Input, OnInit , CUSTOM_ELEMENTS_SCHEMA} from '@angular/core';
import { UserService } from '@app/core/services/user/user.service';
import { WarningService } from '@app/core/services/warning/warning.service';
import { ModalController } from '@ionic/angular';
import { Auth } from 'aws-amplify';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'app-user-account-verify-email-modal',
    templateUrl: './user-account-verify-email-modal.component.html',
    styleUrls: ['./user-account-verify-email-modal.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class UserAccountVerifyEmailModalComponent implements OnInit {
    @Input() email: string;
    type = 'email';
    code: string = '';

    constructor(private warning: WarningService, private modalCtrl: ModalController, private userService: UserService) {}

    ngOnInit(): void {
        if (this.email) {
            this.userService.updateUserEmailAuth({ email: this.email }).subscribe((response) => {
                if (response.success) {
                    this.updateAuthUser();
                } else {
                    this.warning.create('We could not valid the email address. Please contact support for assistance.');
                    this.dismiss(false);
                }
            });
        }
    }

    async sendCodeToEmail() {
        Auth.verifyCurrentUserAttribute('email')
            .then(() => {/* empty */})
            .catch((e) => {
                console.log(e);
            });
    }

    async sendCodeToPhone() {
        Auth.verifyCurrentUserAttribute('phone_number')
            .then(() => {/* empty */})
            .catch((e) => {
                console.log(e);
            });
    }

    async updateAuthUser() {
        const user = await Auth.currentAuthenticatedUser();

        if (this.type === 'email') {
            try {
                Auth.updateUserAttributes(user, {
                    email: this.email,
                }).then(() => {
                    this.sendCodeToEmail();
                });
            } catch (error) {
                this.warning.create('Invalid Email');
                this.dismiss(false);
            }
        }
    }

    resendCode() {
        if (this.type === 'email') {
            this.sendCodeToEmail();
        } else if (this.type === 'phone') {
            this.sendCodeToPhone();
        }
    }

    async verifyCodeFromEmail() {
        if (this.code) {
            const attribute = this.type === 'email' ? 'email' : 'phone_number';
            Auth.verifyCurrentUserAttributeSubmit(attribute, this.code)
                .then(() => {
                    this.dismiss(true);
                })
                .catch((e) => {
                    this.warning.create('Invalid Code', 'Unsuccessful Action');
                    // this.dismiss(false);
                });
        }
    }

    changeEmail() {
        this.dismiss(false);
    }

    dismiss(status: boolean) {
        this.modalCtrl.dismiss({ verified: status });
    }
}
